import axios from "../api/axiosInstance";


export const GetRoleList = async () => {
    return await axios.get("/Role/GetRoleList");
};

export const GetAllPermissions = async () => {
    return await axios.get("/Role/GetAllPermissions");
};

export const GetRolePermissions = async (roleId) => {
    return await axios.get("/Role/GetRolePermissions", {
        params: { roleId },
    });
};

export const AddRole = async (name) => {
    return await axios.post("/Role/AddRole", { name });
};

export const RemoveRole = async (roleId) => {
    return await axios.post("/Role/RemoveRole", null, {
        params: { roleId },
    });
};

export const UpdateRolePermissions = async (roleId, permissions) => {
    return await axios.put("/Role/UpdateRolePermissions", permissions, {
        params: { roleId },
    });
};

export const GetUserRoles = async (userId) => {
    return await axios.get("/Role/GetUserRoles", {
        params: { userId },
    });
};

export const AssignRoleToUser = async (userId, roleName) => {
    return await axios.post("/Role/AssignRoleToUser", { userId, roleName });
};

export const RemoveRoleFromUser = async (userId, roleName) => {
    return await axios.post("/Role/RemoveRoleFromUser", { userId, roleName });
};

export const GetMyRoles = async () => {
    return await axios.get("/Role/GetMyRoles");
};

export const GetUserRolesBasic = async (userId) => {
    return await axios.get("/Role/GetUserRolesBasic", {
        params: { userId },
    });
};

export const GetRoleScopes = async (roleId) => {
    return await axios.get("/Role/GetRoleScopes", {
        params: { roleId },
    });
};

export const UpdateRoleScope = async (roleId, module, scopeValue) => {
    return await axios.put("/Role/UpdateRoleScope", null, {
        params: { roleId, module, scopeValue },
    });
};